/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_5_GoogleInputs */

const en_privacy_section_5_google = /** @type {(inputs: Privacy_Section_5_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Analytics & Google Tag Manager`)
};

const lv_privacy_section_5_google = /** @type {(inputs: Privacy_Section_5_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Analytics un Google Tag Manager`)
};

/**
* | output |
* | --- |
* | "Google Analytics & Google Tag Manager" |
*
* @param {Privacy_Section_5_GoogleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_5_google = /** @type {((inputs?: Privacy_Section_5_GoogleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_5_GoogleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_5_google(inputs)
	return en_privacy_section_5_google(inputs)
});